import styled from 'styled-components';
import { ReactComponent as ArmScoreTrendSvg } from '../../assets/icons/armScoreTrend.svg';

export const DashboardTopLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(260px, 1fr);
  gap: 24px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const DashboardCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: auto;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DashboardLeaderboardWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  /* On stacked tablet/mobile layout, keep leaderboard close to a single summary-card height. */
  @media (max-width: 1100px) {
    max-height: 640px;
  }
`;

export const DashboardCardPlaceholder = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #d8dde3;
  padding: 24px 24px 24px;
  box-shadow: 0 8px 24px rgba(15, 35, 52, 0.06);
  color: #5d6e81;
  font-family: 'Proxima Nova';
  font-size: 14px;
  text-color: #5d6e81;
  min-height: 160px;
  p {
    font-family: 'Proxima Nova';
    font-size: 16px;
    color: #000000;
  }
  p strong {
    font-family: 'Proxima Nova Bold';
    font-weight: 600;
    font-size: 36px;
    color: #000000;
    margin-right: 4px;
  }
`;

export const ArmScoreCard = styled(DashboardCardPlaceholder)`
  background: #FBFCFD;
  border: 1px solid #D8DDE3;
  padding: 20px;
`;

export const TotalArmStrengthCard = styled(DashboardCardPlaceholder)`
  background: #FBFCFD;
  border: 1px solid #D8DDE3;
  padding: 20px;
`;

export const MetricTitleGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
`;

export const MetricCardRangeLabel = styled.span`
  font-size: 12px;
  color: #000000;
  font-family: 'Proxima Nova', sans-serif;
  font-weight: 400;
`;

export const MetricSubGrid = styled.div<{ $variant?: 'blue' | 'green' }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin-top: 12px;

  
  > div:nth-child(1) { border-radius: 16px 0 0 0; }
  > div:nth-child(2) { border-radius: 0 16px 0 0; }
  > div:nth-child(3) { border-radius: 0 0 0 16px; }
  > div:nth-child(4) { border-radius: 0 0 16px 0; }

  > div {
    background: ${({ $variant }) =>
      $variant === 'blue'
        ? 'linear-gradient(90deg, #FBFCFD 0%, #E3EFFB 100%)'
        : 'linear-gradient(90deg, #FBFCFD 0%, #EAF9EC 100%)'};
    border: ${({ $variant }) =>
      $variant === 'blue' ? '1px solid #DBE9F7' : '1px solid #D7EFDA'};
  }
`;

export const MetricSubTile = styled.div`
  background: transparent;
  padding: 8px 8px 8px 16px;
  position: relative;
  min-height: 108px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MetricSubTileLabel = styled.div`
  font-size: 14px;
  font-family: 'Proxima Nova Bold', sans-serif;
  font-weight: 700;
  color: #38424D;
  position: relative;
  z-index: 1;
`;

export const MetricSubTileValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
  position: relative;
  z-index: 1;
`;

export const MetricSubTileNumber = styled.span`
  font-size: 36px;
  font-family: 'Proxima Nova Bold', sans-serif;
  font-weight: 700;
  color: #2B323B;
  line-height: 1;
`;

export const MetricSubTileUnit = styled.span`
  font-size: 16px;
  font-family: 'Proxima Nova', sans-serif;
  color: #38424D;
`;

export const MetricSubTileSubtext = styled.div`
  font-size: 14px;
  font-family: 'Proxima Nova', sans-serif;
  color: #7D8DA0;
  position: relative;
  z-index: 1;
`;

export const MetricTileArrowIconWrap = styled.div`
  position: absolute;
  right: -4px;
  top: 55%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 0;

  svg {
    display: block;
    width: 82px;
    height: 78px;
  }
`;

export const MetricTileBarsIconWrap = styled.div`
  position: absolute;
  right: -4px;
  top: 55%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 0;

  svg {
    display: block;
    width: 92px;
    height: 78px;
  }
`;

export const MetricTileCheckIconWrap = styled.div`
  position: absolute;
  right: -2px;
  top: 55%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 0;

  svg {
    display: block;
    width: 106px;
    height: 90px;
  }
`;

export const MetricTileTeamIconWrap = styled.div`
  position: absolute;
  right: 4px;
  top: 55%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 0;

  svg {
    display: block;
    width: 82px;
    height: 72px;
  }
`;


export const MetricCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const MetricTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  text-transform: uppercase;
  font-family: 'Proxima Nova Bold';
  color: #2B323B;
`;

export const MetricInfoIcon = styled.button`
  border: 1px solid #d3d8e0;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #5d6e81;
  font-size: 11px;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
`;

/** Popover body; visibility toggled by ${MetricInfoTooltipWrap} hover / focus-within */
export const MetricTooltipBubble = styled.div`
  position: absolute;
  z-index: 1200;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + 10px);
  min-width: 200px;
  max-width: min(280px, calc(100vw - 24px));
  padding: 10px 12px;
  border-radius: 8px;
  background: #ffffff;
  color: #000000;
  font-size: 12px;
  line-height: 1.45;
  font-family: 'Proxima Nova', sans-serif;
  font-weight: 400;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;
  box-shadow: 0 8px 24px rgba(15, 35, 52, 0.06);
  border: 1px solid #d8dde3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.12s ease, visibility 0.12s ease;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: #ffffff transparent transparent transparent;
  }
`;

export const MetricInfoTooltipWrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;

  &:hover ${MetricTooltipBubble},
  &:focus-within ${MetricTooltipBubble} {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

export const MetricDelta = styled.span<{ positive: boolean; negative: boolean }>`
  font-family: 'Proxima Nova Bold';
  color: ${({ positive, negative }) =>
    positive ? '#11A94D' : negative ? '#D64242' : '#1a2c3f'};
  font-size: 44px;
  line-height: 1;
  padding: 0;
  margin: 0;
  display: inline-block;
  vertical-align: baseline;
`;

export const MetricSubText = styled.p`
  margin: 0;
`;

export const MetricTrendIconWrapper = styled.span<{ positive: boolean; negative: boolean }>`
  display: inline-flex;
  align-items: center;
  margin: 0 8px 0 0;
  padding: 0;
  line-height: 1;
  vertical-align: middle;

  svg {
    width: 24px;
    height: 16px;
    transform: ${({ negative }) => (negative ? 'scaleY(-1)' : 'none')};
    stroke: ${({ positive, negative }) =>
      positive ? '#11A94D' : negative ? '#D64242' : '#5d6e81'};
    color: ${({ positive, negative }) =>
      positive ? '#11A94D' : negative ? '#D64242' : '#5d6e81'};
  }
`;

export const TestingList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
`;

export const TestingListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
`;

export const TestingLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-family: 'Proxima Nova';
  font-size: 19px;
`;

export const TestingLabelIcon = styled.span<{ bgColor?: string; iconColor?: string; large?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: ${({ bgColor }) => bgColor ?? '#eef3ff'};

  svg {
    width: ${({ large }) => (large ? '20px' : '16px')};
    height: ${({ large }) => (large ? '20px' : '12px')};
    color: ${({ iconColor }) => iconColor ?? '#5d6e81'};
  }
`;

export const TestingValue = styled.span`
  font-family: 'Proxima Nova Bold';
  font-size: 19px;
  color: #1a2c3f;
`;
export const DashboardActivitySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/* —— Dashboard leaderboard (RFC 0003) —— */
export const LeaderboardCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, #2b91ff 0%, #007bff 100%);
  border: 1px solid #d8dde3;
  padding: 6px;
  height: 100%;
`;

/** List + CTA live inside this blue panel, inset from LeaderboardCard */
export const LeaderboardInnerBlueCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: 4px 8px 8px;
  border-radius: 10px;
  overflow: hidden;
  background: #FFFFFF36;
  border: 1px solid #d8dde3;
`;

export const LeaderboardCardHeader = styled.div`
  padding: 10px 12px 6px;
  color: #ffffff;
`;

export const LeaderboardCardTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const LeaderboardHeaderTrendIcon = styled(ArmScoreTrendSvg)`
  flex-shrink: 0;
  color: #ffffff;
  width: 18px;
  height: 18px;
  margin-top: 2px;
`;

export const LeaderboardCardTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  font-family: 'Proxima Nova Bold', sans-serif;
`;

export const LeaderboardCardSubtitle = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  font-family: 'Proxima Nova';
`;

export const LeaderboardControls = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  gap: 8px;
  padding: 0 8px 6px;
`;

/** Metric (left) / sort (right) — equal flex so both sit on one line */
export const LeaderboardSelect = styled.select`
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  color: #1a2c3f;
  background: #ffffff;
  cursor: pointer;
`;

export const LeaderboardDropdown = styled.div`
  position: relative;
  flex: 1 1 0;
  min-width: 0;
`;

export const LeaderboardDropdownTrigger = styled.button`
  width: 100%;
  min-width: 0;
  padding: 11px 36px 11px 14px;
  border-radius: 8px;
  border: 1px solid #d8dde3;
  background: #f6f7f9;
  color: #24364a;
  font-size: 14px;
  line-height: 1.1;
  font-family: 'Proxima Nova', sans-serif;
  text-align: left;
  cursor: pointer;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: 14px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-right: 2px solid #556273;
    border-bottom: 2px solid #556273;
    transform: translateY(-60%) rotate(45deg);
  }

  @media (max-width: 1024px) {
    font-size: 13px;
    padding: 10px 32px 10px 12px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 9px 28px 9px 10px;
  }
`;

export const LeaderboardDropdownMenu = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 8px);
  z-index: 20;
  border-radius: 8px;
  border: 1px solid #d8dde3;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 35, 52, 0.24);
  padding: 0;
  max-height: min(360px, 52vh);
  overflow-y: auto;
`;

export const LeaderboardDropdownOption = styled.button<{ $selected?: boolean }>`
  width: 100%;
  border: none;
  border-radius: 0;
  background: ${({ $selected }) => ($selected ? '#d6e8f6' : '#ffffff')};
  color: #2f3a45;
  font-size: 14px;
  line-height: 1.15;
  font-family: 'Proxima Nova', sans-serif;
  text-align: left;
  padding: 11px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${({ $selected }) => ($selected ? '#d6e8f6' : '#eef3f9')};
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  @media (max-width: 1024px) {
    font-size: 13px;
    padding: 10px 12px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 9px 10px;
  }
`;

export const LeaderboardDropdownCheck = styled.span`
  width: 12px;
  color: #2f3a45;
  display: inline-flex;
  justify-content: center;
  flex-shrink: 0;

  &:empty {
    display: none;
  }
`;

export const LeaderboardFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const LeaderboardList = styled.ul<{ $scrollable?: boolean }>`
  list-style: none;
  margin: 0;
  flex: 1 1 auto;
  margin-right: ${({ $scrollable }) => ($scrollable ? '2px' : '0')};
  padding: 6px 10px ${({ $scrollable }) => ($scrollable ? '10px' : '4px')};
  min-height: 0;
  max-height: ${({ $scrollable }) => ($scrollable ? 'none' : 'none')};
  overflow-y: ${({ $scrollable }) => ($scrollable ? 'auto' : 'hidden')};
  -webkit-overflow-scrolling: touch;
  scrollbar-color: #FFFFFF3D transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #FFFFFF3D;
    border-radius: 999px;
  }

  /* WebKit brightens the thumb on hover by default; keep the same color. */
  &::-webkit-scrollbar-thumb:hover,
  &::-webkit-scrollbar-thumb:active {
    background: #FFFFFF3D;
  }
`;

/* Sits on light LeaderboardCard (outside inner blue panel) */
export const LeaderboardCta = styled.button`
  display: block;
  width: 100%;
  margin: 0;
  padding-bottom: 10px;
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-family: 'Proxima Nova Semibold', sans-serif;
  cursor: pointer;
  text-align: center;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.85;
    text-decoration: underline;
    color: #ffffff;
  }
`;

export const LeaderboardRow = styled.li<{ $rank?: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 24px;
  margin-bottom: 4px;
  border-radius: 6px;
  border: 1px solid #d8dde3;
  font-size: 16px;
  font-family: ${({ $rank }) =>
    $rank === 1 || $rank === 2 || $rank === 3
      ? "'Proxima Nova Bold', sans-serif"
      : "'Proxima Nova Bold', sans-serif"};
  font-weight: 400;
  color: ${({ $rank }) =>
    $rank === 1 || $rank === 2 || $rank === 3 ? '#000000' : $rank != null ? '#0056B2' : '#1a2c3f'};
  background: ${({ $rank }) => {
    if ($rank === 1) return '#fcca79';
    if ($rank === 2) return '#ffe1b1';
    if ($rank === 3) return '#fff5e5';
    return '#FFFFFF88';
  }};
`;

export const LeaderboardRank = styled.span`
  font-size: 16px;
`;

export const LeaderboardName = styled.span`
  padding-left: 0px;
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LeaderboardScore = styled.span`
  font-variant-numeric: tabular-nums;
  font-size: 16px;
  font-family: 'Proxima Nova Bold';
`;

